// extracted by mini-css-extract-plugin
module.exports = {"voltage":"Voltage_voltage__hvwS9","voltageSelect":"Voltage_voltageSelect__2PR6L","wrapper":"Voltage_wrapper__k47y8"};